import {request, serviceUrl} from "@/utils/request";

//分页获取日志内容
export function listByPage(params) {
    return request({
        method: 'post',
        url: serviceUrl.notificationService + '/notice-record/page',
        data: params
    })
}


// 导出设备操作日志的Excel
export function smsOperationLog(params) {
    return request({
        method: 'post',
        url: serviceUrl.notificationService + '/notice-record/smsOperationLog/export-excel',
        data: params,
        responseType: 'arraybuffer'
    })
}
